import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute(
  '/_private/_route/teams/$teamId/pipelines/$pipelineId/_internal/recommendations',
)();
